if (!customElements.get('oa-recent-files')) {
  customElements.define(
    'oa-recent-files',
    class OaRecentFiles extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        const storageKey = 'oa-recently-viewed-files-v1';
        const current = {
          id: this.dataset.productId || '',
          title: this.dataset.productTitle || 'UNTITLED FILE',
          url: this.dataset.productUrl || '/',
          image: this.dataset.productImage || '',
          collection: this.dataset.productCollection || 'OA ARCHIVE',
          viewedAt: Date.now(),
        };

        let files = [];
        try {
          const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
          if (Array.isArray(stored)) files = stored;
        } catch (error) {
          files = [];
        }

        files = [current, ...files.filter((file) => String(file.id) !== String(current.id))].slice(0, 8);
        try {
          localStorage.setItem(storageKey, JSON.stringify(files));
        } catch (error) {
          // The strip still renders for this visit when storage is unavailable.
        }

        const rail = this.querySelector('[data-oa-recent-files]');
        if (!rail) return;
        rail.replaceChildren();

        files.slice(0, 5).forEach((file, index) => {
          const link = document.createElement('a');
          const photo = document.createElement('span');
          const caption = document.createElement('span');
          const label = document.createElement('strong');
          const meta = document.createElement('small');

          link.className = `oa-recent-files__card oa-recent-files__card--${index}`;
          link.href = file.url || '/';
          link.setAttribute('aria-label', `Open recently viewed file: ${file.title || 'product'}`);
          photo.className = 'oa-recent-files__photo';
          caption.className = 'oa-recent-files__caption';

          if (file.image) {
            const image = document.createElement('img');
            image.src = file.image;
            image.alt = '';
            image.loading = 'lazy';
            image.width = 320;
            image.height = 400;
            photo.append(image);
          } else {
            photo.textContent = 'OA';
          }

          label.textContent = file.title || 'UNTITLED FILE';
          meta.textContent = index === 0 ? 'CURRENT FILE' : `${file.collection || 'OA ARCHIVE'} // RECENT`;
          caption.append(label, meta);
          link.append(photo, caption);
          rail.append(link);
        });
      }
    }
  );
}
